module.exports = __webpack_public_path__ + "img/2_10.caf6b4b8.png";